"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Editor = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PostEditor = _interopRequireDefault(require("@insided/shared/uikit/PostEditor"));

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _AvatarPlaceholder = _interopRequireDefault(require("@insided/shared/icons/AvatarPlaceholder"));

var _userAvatar = require("@insided/shared/utils/userAvatar");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function replyDraftHasContent(html, attachments) {
  if (attachments.length > 0) return true;
  return _htmlParser.default.hasContent(html !== null && html !== void 0 ? html : '');
}

var Editor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor() {
    var _this$props$attachmen;

    var _this;

    (0, _classCallCheck2.default)(this, Editor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "editorRootRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: _this.props.content,
      attachments: (_this$props$attachmen = _this.props.attachments) !== null && _this$props$attachmen !== void 0 ? _this$props$attachmen : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      _this.setState({
        content: content,
        attachments: attachments
      }, function () {
        var _this$props$onDraftCh, _this$props;

        (_this$props$onDraftCh = (_this$props = _this.props).onDraftChange) === null || _this$props$onDraftCh === void 0 ? void 0 : _this$props$onDraftCh.call(_this$props, replyDraftHasContent(content, attachments));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEditorRootFocusIn", function (e) {
      if (!_this.props.onFocusScopeChange) return;
      var root = e.currentTarget;
      var prev = e.relatedTarget;

      if (!prev || !root.contains(prev)) {
        _this.props.onFocusScopeChange(true);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEditorRootFocusOut", function (e) {
      if (!_this.props.onFocusScopeChange) return;
      var root = e.currentTarget;
      var next = e.relatedTarget;

      if (!next || !root.contains(next)) {
        _this.props.onFocusScopeChange(false);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Editor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncEditorRootFocusScopeListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.teardownEditorRootFocusScopeListeners();
    }
  }, {
    key: "teardownEditorRootFocusScopeListeners",
    value: function teardownEditorRootFocusScopeListeners() {
      var el = this.editorRootRef.current;
      if (!el) return;
      el.removeEventListener('focusin', this.onEditorRootFocusIn);
      el.removeEventListener('focusout', this.onEditorRootFocusOut);
    }
  }, {
    key: "syncEditorRootFocusScopeListeners",
    value: function syncEditorRootFocusScopeListeners() {
      this.teardownEditorRootFocusScopeListeners();
      var el = this.editorRootRef.current;
      if (!el || !this.props.onFocusScopeChange) return;
      el.addEventListener('focusin', this.onEditorRootFocusIn);
      el.addEventListener('focusout', this.onEditorRootFocusOut);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          isOpen = _this$props2.isOpen,
          onFocus = _this$props2.onFocus,
          _onCancel = _this$props2.onCancel,
          placeholder = _this$props2.placeholder,
          parentTopicId = _this$props2.parentTopicId,
          contentType = _this$props2.contentType,
          disableFileAttachments = _this$props2.disableFileAttachments,
          currentUser = _this$props2.currentUser,
          _onSuccess = _this$props2.onSuccess,
          replyId = _this$props2.replyId,
          onInstanceReady = _this$props2.onInstanceReady,
          _this$props2$redirect = _this$props2.redirect,
          redirect = _this$props2$redirect === void 0 ? true : _this$props2$redirect,
          isTopicEdit = _this$props2.isTopicEdit,
          parentReplyId = _this$props2.parentReplyId,
          _this$props2$isContro = _this$props2.isControl,
          isControl = _this$props2$isContro === void 0 ? false : _this$props2$isContro,
          mentionTargetReplyAuthor = _this$props2.mentionTargetReplyAuthor,
          _this$props2$editorRo = _this$props2.editorRootId,
          editorRootId = _this$props2$editorRo === void 0 ? 'reply-editor' : _this$props2$editorRo;
      var _this$state = this.state,
          content = _this$state.content,
          attachments = _this$state.attachments;
      var avatarContent;

      if (currentUser.id) {
        if (currentUser.avatar) {
          avatarContent = (0, _preact.h)("img", {
            src: (0, _absoluteUrlRuntime.resolveUrl)(currentUser.avatar),
            alt: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
            className: "editor__avatar-img"
          });
        } else {
          avatarContent = (0, _preact.h)("div", {
            className: "default-avatar default-editor-avatar avatar-variant-".concat(currentUser.id % 10, " editor__avatar-img")
          }, (0, _userAvatar.getAvatarInitial)(currentUser === null || currentUser === void 0 ? void 0 : currentUser.name));
        }
      } else {
        avatarContent = (0, _preact.h)("div", {
          className: "default-avatar"
        }, (0, _preact.h)(_AvatarPlaceholder.default, null));
      }

      return (0, _preact.h)("div", {
        ref: this.editorRootRef,
        id: editorRootId,
        className: (0, _classnames.default)('editor', {
          'editor--open': isOpen
        })
      }, (0, _preact.h)("div", {
        className: "editor__container"
      }, isOpen ? (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref) {
        var lock = _ref.lock,
            unlock = _ref.unlock;
        return (0, _preact.h)("div", {
          className: "qa-topic-post-edit"
        }, (0, _preact.h)(_PostEditor.default, {
          type: contentType,
          data: content,
          autoFocus: true,
          disableFileAttachments: disableFileAttachments,
          topicId: parentTopicId,
          parentReplyId: parentReplyId,
          replyId: replyId,
          isControl: isControl,
          attachments: attachments,
          redirect: redirect,
          isGuest: currentUser.id === null,
          onChange: function onChange(content, attachments) {
            lock(content);

            _this2.onChange(content, attachments);
          },
          profile: isTopicEdit ? 'topicEdit' : 'reply',
          callback: mentionTargetReplyAuthor,
          onSuccess: function onSuccess(content, attachments) {
            unlock();

            if (_onSuccess) {
              _onSuccess(content, attachments);

              _this2.setState({
                content: '',
                attachments: []
              });
            } else {
              window.location.reload();
            }
          },
          onCancel: function onCancel() {
            unlock();

            if (_onCancel) {
              _onCancel();
            }
          },
          onInstanceReady: onInstanceReady,
          isTopicEdit: isTopicEdit,
          placeholder: isControl ? placeholder : 'threaded.replies.editor.placeholder'
        }));
      }) : (0, _preact.h)("button", {
        className: "editor__collapsed",
        "data-qa": "open-reply-editor",
        onClick: onFocus,
        "aria-label": "Open reply editor"
      }, (0, _preact.h)("div", {
        className: "editor__avatar"
      }, avatarContent), (0, _preact.h)("input", {
        type: "text",
        className: "editor__input",
        placeholder: placeholder,
        onFocus: currentUser.id ? onFocus : undefined,
        readOnly: true
      }))));
    }
  }]);
  return Editor;
}(_preact.Component);

exports.Editor = Editor;